var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-module"}},[(_vm.template)?_c('template-create-module-form',{attrs:{"template":_vm.template}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }